<template>
  <div id="app">
    <title-input label="Book title" />

    <unit-input v-model="unit" class="unit" />

    <progress-input label='Start' v-model="startProgress" />
    <progress-input label='Goal' v-model="endProgress" />

    <date-input label='Start' v-model="startDate" />
    <date-input label='Due' v-model="dueDate" />

    <copy-button label="Copy tasks to clipboard" selector="#steps" class="unit" />

    <details id="steps">
      <task-item v-for="item in tasks"
        v-bind:key="item.name"
        v-bind:name="item.name"
        v-bind:options="item.options" />
    </details>
  </div>
</template>

<script>
import CopyButton from './components/CopyButton.vue';
import DateInput from './components/DateInput.vue';
import ProgressInput from './components/ProgressInput.vue';
import TaskItem from './components/TaskItem.vue';
import TitleInput from './components/TitleInput.vue';
import UnitInput from './components/UnitInput.vue';

import tasks from './tasks';

function mapStateBidirectionally(state, mutation, via) {
  const getVia = via === undefined ? 'getters' : via;

  function getViaGetter() {
    return this.$store.getters[state];
  }

  function getViaStore() {
    return this.$store[state];
  }

  let get;
  if (getVia === 'getters') {
    get = getViaGetter;
  } else if (getVia === 'state') {
    get = getViaStore;
  } else {
    throw Error('Problem choosing a get via pathway.');
  }

  return {
    [state]: {
      get,
      set(value) {
        return this.$store.commit(mutation, value);
      },
    },
  };
}

export default {
  name: 'app',
  components: {
    CopyButton,
    DateInput,
    ProgressInput,
    TaskItem,
    TitleInput,
    UnitInput,
  },
  computed: {
    title() { return this.$store.state.title; },
    startProgressDisplay() { return this.$store.getters.startProgressDisplay; },
    endProgresDisplay() { return this.$store.getters.endProgressDisplay; },
    ...mapStateBidirectionally('startProgress', 'setStartProgress', 'getters'),
    ...mapStateBidirectionally('endProgress', 'setEndProgress', 'getters'),
    startDate: {
      get() { return this.$store.state.startDate; },
      set(value) { return this.$store.commit('setStartDate', value); },
    },
    dueDate: {
      get() { return this.$store.state.dueDate; },
      set(value) { this.$store.commit('setDueDate', value); },
    },
    unit: {
      get() { return this.$store.state.unit; },
      set(value) { this.$store.dispatch('setUnit', value); },
    },
    tasks() { return tasks.taskList(); },
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 200%;
}

.input {
  display: flex;
  justify-content: space-between;
  width: 50vw;
  margin: .1em auto 0 auto;
}

.unit {
  display: flex;
  justify-content: space-evenly;
  width: 50vw;
  margin: .1em auto 0 auto;
}

#steps {
  width: 50vw;
  margin: .1em auto 0 auto;
}

#steps pre {
  font-size: 50%;
}

input, button {
  font-size: 100%;
}
</style>
